(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[60346],{

/***/ 208992:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/default/desktop/brands/[brandId]",
      function () {
        return __webpack_require__(217115);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 217115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ brands_brandId_; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/dynamic.js
var dynamic = __webpack_require__(85470);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/router.js
var next_router = __webpack_require__(35304);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
;// CONCATENATED MODULE: ./tenants/_template/desktop/brands/[brandId].tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







const BlockPage = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57645), __webpack_require__.e(18089), __webpack_require__.e(15930), __webpack_require__.e(40212), __webpack_require__.e(34785), __webpack_require__.e(48764), __webpack_require__.e(80771), __webpack_require__.e(6015), __webpack_require__.e(38361), __webpack_require__.e(40149), __webpack_require__.e(1528), __webpack_require__.e(27512), __webpack_require__.e(90823), __webpack_require__.e(24930), __webpack_require__.e(71925), __webpack_require__.e(40364), __webpack_require__.e(86827), __webpack_require__.e(23474), __webpack_require__.e(52237), __webpack_require__.e(92185), __webpack_require__.e(31871), __webpack_require__.e(17122), __webpack_require__.e(65725), __webpack_require__.e(60051), __webpack_require__.e(23862), __webpack_require__.e(44829), __webpack_require__.e(40440), __webpack_require__.e(29830), __webpack_require__.e(66673), __webpack_require__.e(6748), __webpack_require__.e(4499), __webpack_require__.e(49986), __webpack_require__.e(9508), __webpack_require__.e(10102), __webpack_require__.e(2835), __webpack_require__.e(21111), __webpack_require__.e(42129), __webpack_require__.e(25919), __webpack_require__.e(58705), __webpack_require__.e(75827), __webpack_require__.e(87310), __webpack_require__.e(58263), __webpack_require__.e(60544), __webpack_require__.e(95154), __webpack_require__.e(20510), __webpack_require__.e(2530), __webpack_require__.e(30162), __webpack_require__.e(29745), __webpack_require__.e(97103), __webpack_require__.e(16611), __webpack_require__.e(80025), __webpack_require__.e(93129), __webpack_require__.e(57663), __webpack_require__.e(64976)]).then(__webpack_require__.bind(__webpack_require__, 864976)).then((mod)=>mod.BlockPage), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(864976)
            ]
    }
});
const SearchPage = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(15930), __webpack_require__.e(40212), __webpack_require__.e(34785), __webpack_require__.e(48764), __webpack_require__.e(80771), __webpack_require__.e(6015), __webpack_require__.e(38361), __webpack_require__.e(40149), __webpack_require__.e(1528), __webpack_require__.e(27512), __webpack_require__.e(90823), __webpack_require__.e(24930), __webpack_require__.e(71925), __webpack_require__.e(40364), __webpack_require__.e(86827), __webpack_require__.e(23474), __webpack_require__.e(52237), __webpack_require__.e(92185), __webpack_require__.e(31871), __webpack_require__.e(17122), __webpack_require__.e(65725), __webpack_require__.e(60051), __webpack_require__.e(23862), __webpack_require__.e(44829), __webpack_require__.e(40440), __webpack_require__.e(29830), __webpack_require__.e(66673), __webpack_require__.e(6748), __webpack_require__.e(4499), __webpack_require__.e(49986), __webpack_require__.e(9508), __webpack_require__.e(10102), __webpack_require__.e(2835), __webpack_require__.e(21111), __webpack_require__.e(42129), __webpack_require__.e(25919), __webpack_require__.e(58705), __webpack_require__.e(75827), __webpack_require__.e(87310), __webpack_require__.e(58263), __webpack_require__.e(60544), __webpack_require__.e(95154), __webpack_require__.e(20510), __webpack_require__.e(2530), __webpack_require__.e(30162), __webpack_require__.e(29745), __webpack_require__.e(97103), __webpack_require__.e(16611), __webpack_require__.e(80025), __webpack_require__.e(60687), __webpack_require__.e(37070), __webpack_require__.e(97968), __webpack_require__.e(50643), __webpack_require__.e(52267)]).then(__webpack_require__.bind(__webpack_require__, 325552)).then((mod)=>mod.SearchPage), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(325552)
            ]
    }
});
const getServerSideProps = (context)=>{
    var ref, ref1;
    return !(context === null || context === void 0 ? void 0 : (ref = context.req) === null || ref === void 0 ? void 0 : (ref1 = ref.tenantEnv) === null || ref1 === void 0 ? void 0 : ref1.epicPb1887) ? getServerSidePropsBlockPage(context) : getServerSidePropsBrandPage(context);
};
const BrandPage = (_param)=>{
    var { seoInfo  } = _param, props = _objectWithoutProperties(_param, [
        "seoInfo"
    ]);
    const { baseDomain , epicPb1887 , canonicalDomain  } = (0,GlobalDataContext/* useGlobalData */.U5)();
    const router = (0,next_router.useRouter)();
    const { query  } = router;
    const brandName = query.brandId.toUpperCase();
    const hasbrandDescription = (0,i18n.t)("brandPageDescription") !== "brandPageDescription";
    const hasConfigBrandTitle = (0,i18n.t)("brandPageTitle") !== "brandPageTitle";
    let canonical;
    if (seoInfo === null || seoInfo === void 0 ? void 0 : seoInfo.canonical) {
        if (canonicalDomain) {
            canonical = "".concat(canonicalDomain).concat(seoInfo.canonical);
        } else if (baseDomain) {
            canonical = "".concat(baseDomain).concat(seoInfo.canonical);
        }
    }
    const pageSeoInfo = {
        metaTitle: hasConfigBrandTitle ? (0,i18n.t)("brandPageTitle", {
            brandName
        }) : seoInfo === null || seoInfo === void 0 ? void 0 : seoInfo.metaTitle,
        description: hasbrandDescription ? (0,i18n.t)("brandPageDescription", {
            brandName
        }) : seoInfo === null || seoInfo === void 0 ? void 0 : seoInfo.metaDescription,
        canonical,
        keywords: seoInfo === null || seoInfo === void 0 ? void 0 : seoInfo.metaKeywords
    };
    const pageProps = _objectSpreadProps(_objectSpread({}, props), {
        seoInfo: pageSeoInfo
    });
    return !epicPb1887 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockPage, _objectSpread({}, pageProps)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchPage, _objectSpread({}, pageProps));
};
/* harmony default export */ var _brandId_ = (BrandPage);

;// CONCATENATED MODULE: ./pages/default/desktop/brands/[brandId].tsx
// AUTO GENERATED FILE. DO NOT EDIT.

var __N_SSP = true;
/* harmony default export */ var brands_brandId_ = (_brandId_);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [97270,57645,98348,91961,300,92888,14560,40179], function() { return __webpack_exec__(208992); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);